// extracted by mini-css-extract-plugin
export var active = "_i0-2";
export var recordingDot = "_i0-1";
export var recordingIndicator = "_i0-0";